export default function PartnershipSection() {
  return (
    <section id="partenariat" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-16">
          {/* Left: Content */}
          <div className="w-full lg:w-1/2">
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Certifications &amp; Qualifications</span>
            <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Une entreprise <span className="text-[#00a340]">qualifiée et reconnue</span>
            </h2>
            <div className="w-12 h-1 bg-[#00a340] rounded-full mb-4"></div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 text-justify">
              KS BTP est une entreprise <strong className="text-gray-800">sérieuse et professionnelle en étanchéité</strong>, reconnue pour la qualité de ses interventions. Nos garanties assurent à nos clients des prestations conformes aux normes les plus exigeantes du secteur.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5 text-justify">
              Nous travaillons avec les meilleurs fournisseurs de matériaux d&apos;étanchéité — membranes bitumineuses, géomembranes, résines liquides — parfaitement adaptés à la nature des projets et aux contraintes climatiques de la région.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-5">
              {[
                { icon: "ri-shield-check-line", label: "Assurance décennale", desc: "Garantie 10 ans sur tous nos ouvrages" },
                { icon: "ri-group-line", label: "Équipes formées", desc: "Personnel qualifié en étanchéité" },
                { icon: "ri-tools-line", label: "Savoir-faire reconnu", desc: "Expertise technique en étanchéité" },
                { icon: "ri-trophy-line", label: "Références solides", desc: "500+ chantiers réalisés en Île-de-France" },
              ].map((item) => (
                <div key={item.label} className="flex gap-3 p-3 md:p-4 rounded-xl bg-[#f5fdf8] border border-gray-100">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#e6f7ed] text-[#00a340] flex-shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-800 text-xs mb-0.5">{item.label}</div>
                    <div className="text-gray-500 text-xs">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Sous-traitance note */}
            <div className="flex items-start gap-3 p-4 rounded-xl bg-[#e6f7ed] border border-[#a8f0c0]">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#00a340] text-white flex-shrink-0 mt-0.5">
                <i className="ri-team-line text-sm"></i>
              </div>
              <div>
                <div className="font-bold text-gray-800 text-sm mb-1">Études de synthèse en sous-traitance</div>
                <div className="text-gray-600 text-xs leading-relaxed text-justify">
                  Les études de synthèse sont exécutées par une société extérieure de confiance, avec laquelle nous travaillons depuis la création de l&apos;entreprise, garantissant une expertise technique de haut niveau.
                </div>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden" style={{ height: "260px" }}>
              <img
                src="https://static.readdy.ai/image/8892c16dc9d95083db2eef95f931ffc6/66d6e5a8ec1041ab1a51bb5caea2aaae.png"
                alt="Certifications KS BTP Étanchéité"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-4 left-4 flex gap-2 md:gap-3">
                {["Décennale", "Expertise", "500+ chantiers"].map((cert) => (
                  <div key={cert} className="bg-white/90 backdrop-blur-sm rounded-lg px-2 md:px-3 py-1.5">
                    <span className="text-xs font-black text-gray-800">{cert}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
